import React, { useState, useRef, useEffect } from "react";
import calendarIcon from "../Assets/Icons/today.png";
import errorIcon from "../Assets/Icons/error_message.png";
import "../App.css";

const MonthYearCal = ({ onChange, value, errorMessage, disableFuture = false }) => {
    console.log('MonthYearCal value', value)
    const [selectedMonth, setSelectedMonth] = useState(new Date().getMonth());
    const [selectedYear, setSelectedYear] = useState(new Date().getFullYear());
    const [showPicker, setShowPicker] = useState(false);
    const calendarRef = useRef(null);

    // Close on outside click
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (calendarRef.current && !calendarRef.current.contains(event.target)) {
                setShowPicker(false);
            }
        };
        if (showPicker) {
            document.addEventListener("mousedown", handleClickOutside);
        }
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [showPicker]);

    // Initialize from value
    useEffect(() => {
        console.log('MonthYearCal useeffect value', value)
        if (value && /^\d{4}-\d{2}$/.test(value)) {
            const [year, month] = value.split("-");
            setSelectedYear(parseInt(year, 10));
            setSelectedMonth(parseInt(month, 10) - 1);
        } else {
            setSelectedMonth(null);
            setSelectedYear(new Date().getFullYear());
        }
    }, [value]);

    const months = [
        "January", "February", "March", "April", "May", "June",
        "July", "August", "September", "October", "November", "December"
    ];

    const formatDisplay = (month, year) => {
        if (month == null || year == null) return "";
        return `${(month + 1).toString().padStart(2, '0')}/${year}`; // MM/YYYY
    };

    const handleSelection = (month, yearPassed) => {
        const current = new Date();
        const selectedDate = new Date(yearPassed, month);

        if (disableFuture && selectedDate > current) {
            return; // ❌ Block selection if it's a future month
        }

        setSelectedMonth(month);
        setSelectedYear(yearPassed);
        setShowPicker(false);

        const returnFormat = `${yearPassed}-${(month + 1).toString().padStart(2, '0')}`;
        onChange && onChange(returnFormat);
    };

    const handleYearChange = (delta) => {
        const currentYear = new Date().getFullYear();
        const newYear = selectedYear + delta;

        if (disableFuture && newYear > currentYear) return;

        setSelectedYear(newYear);

        if (selectedMonth != null) {
            const currentMonth = new Date().getMonth();
            if (
                disableFuture &&
                newYear === currentYear &&
                selectedMonth > currentMonth
            ) {
                setSelectedMonth(null);
                onChange && onChange('');
                return; // prevent updating if selected month is in future of same year
            }

            const returnFormat = `${newYear}-${(selectedMonth + 1).toString().padStart(2, '0')}`;
            onChange && onChange(returnFormat);
        }
    };

    return (
        <div style={{ position: "relative", display: "flex", flexDirection: "column" }} ref={calendarRef}>
            <input
                type="text"
                readOnly
                value={selectedMonth != null ? formatDisplay(selectedMonth, selectedYear) : ""}
                placeholder="MM/YYYY"
                onClick={() => setShowPicker(!showPicker)}
                className="dateMonthBox"
                style={{ border: errorMessage ? "1px solid red" : "1px solid #d6e4ec" }}
            />

            <img
                src={calendarIcon}
                alt="Calendar"
                style={{ width: "16px", height: "16px", cursor: "pointer", position: 'absolute', top: 10, right: 10 }}
                onClick={() => setShowPicker(!showPicker)}
            />

            {showPicker && (
                <div style={{
                    position: "absolute",
                    top: "45px",
                    left: "5px",
                    backgroundColor: "white",
                    border: "1px solid #ccc",
                    padding: "10px",
                    boxShadow: "0px 2px 5px rgba(0,0,0,0.2)",
                    zIndex: 1000,
                    borderRadius: "4px",
                }}>
                    <div style={{
                        display: "flex",
                        justifyContent: "space-between",
                        marginBottom: "10px",
                        alignItems: "center"
                    }}>
                        <button
                            onClick={() => handleYearChange(-1)}
                            style={{ background: "none", border: "none", cursor: "pointer", fontSize: "14px" }}
                        >
                            ◀
                        </button>
                        <span style={{ fontSize: "14px", fontWeight: "bold" }}>
                            {selectedYear}
                        </span>
                        <button
                            onClick={() => handleYearChange(1)}
                            disabled={disableFuture && selectedYear >= new Date().getFullYear()}
                            style={{
                                background: "none", border: "none", fontSize: "14px",
                                cursor: disableFuture && selectedYear >= new Date().getFullYear() ? "not-allowed" : "pointer",
                                color: disableFuture && selectedYear >= new Date().getFullYear() ? "#ccc" : "black"
                            }}
                        >
                            ▶
                        </button>
                    </div>

                    <div style={{ display: "grid", gridTemplateColumns: "repeat(3, 1fr)", gap: "6px" }}>
                        {months.map((monthName, index) => {
                            const isFuture =
                                disableFuture &&
                                (selectedYear > new Date().getFullYear() ||
                                    (selectedYear === new Date().getFullYear() && index > new Date().getMonth()));

                            return (
                                <button
                                    key={monthName}
                                    onClick={() => !isFuture && handleSelection(index, selectedYear)}
                                    className="hover-button"
                                    disabled={isFuture}
                                    style={{
                                        padding: "6px",
                                        fontSize: "12px",
                                        borderRadius: "4px",
                                        border: "none",
                                        cursor: isFuture ? "not-allowed" : "pointer",
                                        backgroundColor: selectedMonth === index ? "blue" : "#f8f8f8",
                                        color: selectedMonth === index ? "white" : "black",
                                        opacity: isFuture ? 0.5 : 1,
                                    }}
                                >
                                    {monthName}
                                </button>
                            );
                        })}
                    </div>
                </div>
            )}

            {errorMessage && (
                <div style={styles.errorMessage}>
                    <span>
                        <img src={errorIcon} alt="Error" style={{ width: "12px", height: "12px" }} />
                    </span>{" "}
                    {errorMessage}
                </div>
            )}
        </div>
    );
};

const styles = {
    errorMessage: {
        color: "#EE201C",
        fontSize: "11px",
        marginTop: "4px",
        display: "flex",
        gap: "4px",
        fontWeight: "400",
    },
};

export default MonthYearCal;
